import React, { Fragment, useState } from 'react';
import {
  TextField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  useTranslate,
  ArrayField,
  ChipField,
  SingleFieldList,
} from 'react-admin';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ShowController, LocalSort } from '~/components/ra';
import { Longdash } from '~/utils';
import FXMappingShow from '~/resources/currencies/components/FXMappingShow';
import FXMappingCreate from '~/resources/currencies/components/FXMappingCreate';
import { SelectTransactionType } from '~/components/TransactionsHistory/components/SelectTransactionType';
import RaPagination from '~/components/Pagination/RaPagination';
import { rowsPerPageOptionsDefault, perPageDefault } from '~/utils/pagination';

interface FXMappingTabProps {
  record?: any;
  permissions?: any;
  [x: string]: any;
}

const FXMappingTab = (props: FXMappingTabProps) => {
  const { record, permissions, ...rest } = props;
  const classes = useStyles();

  const translate = useTranslate();
  const t = (key: string) => translate(`resources.solutions.fxmappings.${key}`);

  const [showData, setShowData] = useState(null);
  const handleOpen = (data: any) => {
    (permissions.includes('solution.fxmapping.view') || true) && setShowData(data);
  };
  const handleClose = () => setShowData(null);

  return (
    <Fragment>
      <FXMappingShow
        record={showData}
        permissions={permissions}
        solutionRecord={record}
        onClose={handleClose}
        {...rest}
      />
      <Grid container justify='flex-end' className={classes.spacings}>
        <Grid item>
          <FXMappingCreate permissions={permissions} solutionRecord={record} />
        </Grid>
      </Grid>
      <ReferenceManyField
        label='Configurations'
        reference='fxrates/mappings'
        target='solutions'
        sort={{ field: 'id', order: 'ASC' }}
        pagination={
          <RaPagination
            defaultPerPage={perPageDefault}
            rowsPerPageOptions={rowsPerPageOptionsDefault}
          />
        }
        perPage={perPageDefault}
        {...props}
      >
        <LocalSort>
          <Datagrid rowClick={(_id: any, _basePath: any, record: any) => handleOpen(record)}>
            <ReferenceField source='productId' reference='products' link={false} addLabel={false}>
              <TextField source='name' />
            </ReferenceField>
            <ArrayField source='operationTypes' label={t('operationTypes')} sortable={false}>
              <SingleFieldList linkType={false}>
                <ShowController>
                  {({ showRecord, ...rest }) => {
                    if (!showRecord) return Longdash;
                    return (
                      <ChipField
                        record={{ name: translate(SelectTransactionType.l(showRecord)) }}
                        source='name'
                        {...rest}
                      />
                    );
                  }}
                </ShowController>
              </SingleFieldList>
            </ArrayField>
            {/*<ShowController>
                {({ showRecord: mappingRecord, ...restMapping }) => {
                  return (
                    <ArrayField
                      source="kycLevels"
                      record={mappingRecord}
                      sortable={false}
                      {...restMapping}
                    >
                      <SingleFieldList linkType={false}>
                        <ShowController>
                          {({ showRecord }) => {
                            if (!showRecord) return Longdash;
                            return (
                              <KycLevelField
                                record={{ name: showRecord, solutionId: mappingRecord.solutionId }}
                                source="name"
                              />
                            );
                          }}
                        </ShowController>
                      </SingleFieldList>
                    </ArrayField>
                  );
                }}
              </ShowController>*/}
            <ArrayField source='tags' label={t('tags')} sortable={false}>
              <SingleFieldList linkType={false}>
                <ShowController>
                  {({ showRecord, ...rest }) => {
                    if (!showRecord) return Longdash;
                    return <ChipField record={{ name: showRecord }} source='name' {...rest} />;
                  }}
                </ShowController>
              </SingleFieldList>
            </ArrayField>
            <ReferenceField
              source='ratesId'
              reference='fxrates'
              link={false}
              addLabel={false}
              sortable={false}
            >
              <TextField source='name' />
            </ReferenceField>
          </Datagrid>
        </LocalSort>
      </ReferenceManyField>
    </Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  spacings: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  link: {
    position: 'relative',
    textDecoration: 'underline',
    textWrap: 'nowrap',
  },
  edit: {
    margin: -12,
    marginRight: -4,
    padding: theme.spacing(1) / 2,
  },
}));

export default FXMappingTab;
